import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { X, ArrowRight } from "lucide-react";
import { useResume } from "@/lib/resume";
import { RESUME_ICONS } from "@/components/ResumeCard";

const SHOW_ON = ["/", "/guides", "/certification"];

// Compact "Continue" pill that floats above the mobile bottom nav on browse pages.
export default function ResumeStrip() {
  const resume = useResume();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [hidden, setHidden] = useState(false);
  if (!resume || hidden || !SHOW_ON.includes(location.pathname)) return null;
  const Icon = RESUME_ICONS[resume.kind] || ArrowRight;
  return (
    <div data-testid="resume-strip" className="lg:hidden fixed left-3 right-3 z-30 bottom-[calc(4rem+env(safe-area-inset-bottom))] animate-in slide-in-from-bottom-4 fade-in duration-300">
      <div className="flex items-center gap-2 rounded-full border border-primary/40 bg-[#0B132B]/95 backdrop-blur-md shadow-lg pl-3 pr-1 py-1">
        <Icon size={16} className="text-primary shrink-0" />
        <button type="button" data-testid="resume-strip-go" onClick={() => navigate(resume.path)} className="min-w-0 flex-1 text-left text-xs text-white py-1.5">
          <span className="text-primary font-bold">{t("resume.short", "Continue")}:</span> <span className="truncate inline-block max-w-[70%] align-bottom">{resume.title}</span>
        </button>
        <button type="button" aria-label="Dismiss" data-testid="resume-strip-dismiss" onClick={() => setHidden(true)} className="h-9 w-9 grid place-items-center rounded-full text-slate-400 hover:text-white"><X size={16} /></button>
      </div>
    </div>
  );
}
